module.exports = {
    "": {
      "locale": "fr",
      "plural-forms": "nplurals=2; plural=n>1;"
    },

    // index: header
    "BobTV is the site of stripping in webcam chat of <a href=\"http://www.bobvoyeur.com/\" target=\"_blank\">Bob Voyeur</a>": "BobTV est le tchat webcam pour adultes de <a href=\"http://www.bobvoyeur.com/\" target=\"_blank\">Bob Voyeur</a>",
    "Stripping of couples making sex in front of their webcam. Free naughty dating and strip-tease by video cam. For stripping among adult amateurs, naughties and sluts. To discover swinging, debauchery or flirting voyeurs": "BobTV est dédié à l'exhibition, des couples font l'amour en cam, des femmes et des hommes s'exhibent nus sur les salles de tchat.<br/>BobTV est le rendez-vous de l'exhib entre amateurs respectueux.",

    // index: rooms
    "Open this room": "Ouvrir cette salle",
    "Open": "Ouvrir",
    "Room is full": 'Salle pleine',
    "Room limit: <strong>%1</strong> users": "Salle limitée à <strong>%1</strong> utilisateurs.",
    "Per room limit: <strong>%1</strong> users": "Salles limitées à <strong>%1</strong> utilisateurs.",
    "These chat rooms can be used on Windows, Mac OS and Android (smartphones and tablets), iOS 12.2 and higher (on iPhone or iPad). It is required to use Google Chrome, Safari, Firefox or Opera browsers (recent versions) or Microsoft Edge starting from version 79. Only Safari is currently compatible with iPhone and iPad iOS version 12.2 and above.": "Ces salles de tchat fonctionnent sous Windows, Mac OS et Androïd (smartphones et tablettes), iOS 12.2 et supérieures (sur iPhone ou iPad). Il est impératif d'utiliser les navigateurs Google Chrome, Safari, Firefox ou Opéra (versions récentes) ou Microsoft Edge à partir de la version 79. Seul Safari est pour le moment compatible avec les iPhone et les iPad en version iOS 12.2 et supérieures.",
    "My BobTV is a platform of free chat rooms available to BobTV subscribers. The creator of each room is the moderator, he is free to manage his own room within in accordance with BobTV's CGU. The themes are varied, such as: blind-test, games, conversations between friends, sexy or soft shows, hard dialogues and crude words ... The creator chooses the theme of his chat room, he welcomes his friends and provides a friendly atmosphere.": "My BobTV est une plateforme de salles de tchat mises gratuitement à disposition des abonnés de BobTV. Le créateur de chaque salle est modérateur, il est libre de gérer son propre salon dans la seule limite des CGU de BobTV. Les thématiques sont variées, telles que : blind-test, jeux, conversations entre amis, shows sexy ou soft, dialogues hard et mots crus... Le créateur choisit le thème de sa salle de tchat, il accueille ses amis et assure une ambiance conviviale.",
    "Compatible": "Compatible",
    "Devices:": "Appareils :",
    "Desktop": "Ordinateur",
    "Tablet": "Tablette",
    "Smartphone": "Smartphone",
    "OS:": "OS :",
    "Browser:": "Navigateur :",
    "ONLINE": "EN DIRECT",
    "Blurred for privacy concerns.": "Flouté par respect de la vie privée.",
    "online": "en ligne",
    "offline": "déconnecté",
    "Room": "Salle",

    'This room is full. Only <span class="XXL">XXL</span> members are allowed to enter.': 'Cette salle est pleine, seuls les membres&nbsp;<span class="XXL">XXL</span> peuvent y entrer.',
    'Become XXL': 'Devenir XXL',

    // index: mybobtv rooms
    "To create a room, you must have a <strong>minimum of %1 days of XXL</strong> (expired or in progress) on your account.": "Pour créer une salle, vous devez avoir un <strong>minimum de %1 jours de XXL</strong> (expirés ou en cours) sur votre compte.",
    "To create a room, you must have a <strong>minimum of %1 days of XXL</strong> (expired or in progress) on your account. You must buy at least %2 days of XXL.": "Pour créer une salle, vous devez avoir un <strong>minimum de %1 jours de XXL</strong> (expirés ou en cours) sur votre compte. Vous devez acheter au moins %2 jours de XXL.",
    "You must be XXL member to create the room.": "Pour créer une salle, vous devez être membre XXL.",
    "Buy %1 days of XXL": "Acheter %1 jours de XXL",
    "Buy XXL": "Acheter XXL",
    "You must be XXL member to open the room.": "Vous devez être membre XXL pour ouvrir la salle.",

    // index: real gifts
    "Last received real gifts": "Les derniers cadeaux réels reçus",
    "%1 given by %2 for %3": "%1 offert par %2 à %3",
    "All wishlists": "Toutes les listes d'envies",

    // index: wall posts
    "Last post of the Wall": "Les derniers posts sur Le Mur",
    "See all posts of the wall": "Tous les posts",

    // index: bobstore submissions
    "Last submissions on": " Les dernières contributions sur",
    "Open Bobstore": "Visiter la boutique",

    // index: amateur films
    "The latest amateur videos": "Les derniers vidéos des bobeuses et bobeurs",

    // index: xxl functions

    // index: virtual gifts
    "The last received virtual gifts": "Les derniers cadeaux virtuels reçus",
    "Anonymous" : "Anonyme",
    "an anonymous" : "un anonyme",

    // index: favourites
    "The favourites of BobTV": "Les favoris de BobTV",
    "The generous of BobTV": "Les généreux de BobTV",
    "List of members who received the greater number of gift points.": "Liste des membres ayant cumulé le plus grand nombre de points-cadeaux.",
    "Each virtual gift received increases your gift rating and you can get into the charts.": "Chaque cadeau virtuel reçu augmente vos points-cadeaux et vous permet de monter dans ce palmarès.",
    "Gift points are valid for 60 days.": "Les points-cadeaux sont valides 60 jours.",
    "The more gift points you have the better status you get in the favourites of BobTV.": "Plus vous cumulez de points-cadeaux et plus votre statut de favori est important dans la communauté de BobTV.",
    "With 100 gift points you get a blue star": "Avec 100 points-cadeaux vous obtenez une étoile bleue",
    "From 200 gift points you get a red star": "A partir de 200 points-cadeaux vous aurez une étoile rouge",
    "and if you have over 500 gift points you receive a golden star": "et au-dessus de 500 points-cadeaux vous serez gratifié d'une étoile d'or",
    "%1 Gift point": [
        "%1 Point-cadeaux",
        "%1 Points-cadeaux",
    ],

    // index: generous users
    "List of members who have given the greatest number of virtual gifts and tokens over the last 60 days.": "Liste des membres ayant offert le plus grand nombre de cadeaux virtuels et de jetons sur les 60 derniers jours.",
    "To be rewarded with a medal, you must give virtual gifts or tokens to other users according to the following scale:": "Pour être gratifié d'une cocarde, vous devez offrir des cadeaux virtuels ou des jetons aux autres utilisateurs selon le barème suivant :",
    'Please note, virtual gifts given anonymously are not counted. You must display your username to "all" when giving a gift.': 'Par ailleurs les cadeaux virtuels offerts en anonyme ne sont pas comptabilisés. Vous devez afficher votre pseudo à "tous" en les offrant.',
    'Only tokens you have purchased are counted.': 'Seuls les jetons que vous avez acheté sont comptabilisés.',
    'The biggest tip of last 60 days': 'Don le plus important depuis 60 jours.',

    // profiles
    "The page BobTV members allows you to search all the profiles registered on the webcam chat": "La page des membres de BobTV vous permet d'effectuer des recherches sur la totalité des profils enregistrés sur le chat webcam.",
    "<p>You can discover the thousands of pages of profiles updated by members of webcam chat and quickly get into contact with them even if they are not in chat rooms at the moment.</p><p>You can find photo albums of all members, their friend lists, send them a message and even give them a virtual gift.</p><p>With this search tool you will certainly make new friends.</p>": "<p>Vous pouvez découvrir les milliers de pages profils mises à jour par les membres du tchat webcam et entrer rapidement en contact avec eux, même s'ils ne sont pas connectés sur les salles.</p><p>Vous pouvez découvrir les albums photos de tous les membres, leur liste d'amis, leur envoyer un message et même leur offrir un cadeau virtuel.</p><p>Cet outil de recherche vous permettra certainement de faire de nouvelles rencontres.</p>",
    "Show more": "Lire plus",
    "Hide more": "Cacher",
    "Show advanced filters": "Afficher les filtres avancés",
    "Exact match": "Pseudo exact",
    "Currently connected": "Connecté actuellement",
    "Certified Bobeurs": "Bobeurs certifiés",
    "Certified Bobeuses": "Bobeuses certifiées",
    "Search": "Chercher",
    "Member nick": "Recherche",
    "Gender": "Genre",
    "Gender:": "Genre :",
    "Age": "Age",
    "Age:": "Age :",
    "from": "de",
    "to": "à",
    "With photo": "Avec photo seulement",
    "Any": "Tous",
    "Member search results": "Résultats pour cette recherche",
    "See all wishlists and offer real gifts": "Consultez toutes les listes d'envies et offrez des cadeaux réels",

    "Select one...": "",
    "Country:": "Pays :",
    "Region:": "Région :",

    "%1 year": [
        "%1 an",
        "%1 ans",
    ],

    // modal menu
    "Home": "Accueil",
    "Profiles": "Les membres",
    "Amateur videos": "Les vidéos amateurs",
    "Videos": "Vidéos",
    "The Wall": "Le Mur",
    "The Wardrobe": "Dressing",
    "Help": "Aide",
    "Contact": "Contact",
    "Links": "Liens",
    "The bobTV blog": "Le blog de BobTV",
    "Validation code:": "Code de validation:",

    'This site uses cookies for statistical purposes only.':
        'Ce site utilise des cookies uniquement à des fins statistiques.',
    Accept: 'Accepter',
    Reject: 'Rejeter',
    'Cookie Management': 'Gestion des Cookies',
    Refuse: 'Refuser',

    "My messages": "Mes messages",
    "Private messages": "Messages Privés",
    "My guest book": "Mon livre d'or",
    "My black list": "Mes blocages",
    "Followees": "Abonnements",
    "My wallet": "Mon porte monnaie virtuel",
    "My virtual gifts": "Mes cadeaux virtuels",
    "My BobTV": "My BobTV",
    "Delete my account": "Supprimer mon compte",
    "Single period, without automatic&nbsp;rebilling. Immediate access": "Période unique, sans renouvellement automatique. Accès&nbsp;immédiat.",
    "Single payment, without automatic&nbsp;rebilling. Immediate access": "Achat unique, sans renouvellement automatique. Accès&nbsp;immédiat.",
    "Access XXL features": "Accédez aux fonctions XXL",
    "Expiration:": "Expire le",
    "MM/DD/YYYY": "DD/MM/YYYY",
    "MM/DD/YYYY [at] HH:mm": "DD/MM/YYYY [à] HH:mm",
    "My membership": "Mon abonnement",
    "Buy more XXL": "Prolonger mon XXL",

    "Log in": "Connexion",
    "Nick is empty": "Entrez votre pseudo",
    "Sign up": "Enregistrement",
    "Registration": "Enregistrement",
    "Activate": "Activer",
    "Nick": "Pseudo",
    "Password": "Mot de passe",
    "Forgot password?": "Mot de passe oublié?",
    "Receive password" :"Mot de passe oublié",
    "Enter your email address or nick to receive your password immediately.": "Entrez votre adresse email ou pseudo pour recevoir immédiatement votre mot de passe.",
    "Enter": "Entrer",
    "Confirm password": "Confirmez le mot de passe",

    "Send": "Valider",

    // Error messages
    "Network Error": "Pas de connexion Internet",
    "Unknown Error": "Erreur inconnue",
    
    // member profile
    "My profile": "Mon profil",
    "About:": "Description :",
    "Save": "Valider",
    "Cancel": "Annuler",
    "Close": "Fermer",
    "Reset": "Annuler",
    "Change": "Modifier",
    "Change password": "Changer de mot de passe",
    "Change email": "Changer d'adresse émail",
    "Change phone": "Changer de numéro de téléphone",
    "Send to phone": "Activer par SMS",

    "Current phone number:": "Numéro de téléphone actuel :",
    "New phone number:": "Nouveau numéro de téléphone :",
    "Confirm your new phone number": "Confirmez votre nouveau numéro de téléphone",
    "Sms has been sent to %1.": "Un SMS a été envoyé à %1.",

    "New nick:": "Nouveau pseudo:",
    "Your request will be rejected in the following cases:": "Votre demande sera rejetée dans les cas suivants :",
    "- Nick vulgar or disrespectful.": "- Pseudo vulgaire ou irrespectueux.",
    "- Referring to a trademark or a personality.": "- Allusion à une marque déposée ou à une personnalité.",
    "- Nick is in capital letters.": "- Pseudo en lettres majuscules.",
    "- Nick already exists.": "- Le pseudo existe déjà.",
    "You have requested a change of nick. We will process it as soon as possible.": "Vous avez demandé un changement de pseudo. Nous allons le traiter dans les meilleurs délais.",

    "Old password:": "Ancien mot de passe :",
    "New password:": "Nouveau mot de passe :",
    "Confirm new password:": "Confirmez le nouveau mot de passe :",
    "Email address and confirmation do not match.": "Les adresses email ne correspondent pas.",
    "Password and confirmation doesn't match": "Les mot de passe ne correspondent pas.",
    "Invalid email": "Cette adresse émail n’est pas correcte.",

    "My photos": "Mes photos",
    "Add a photo": "Ajouter une photo",
    "All my photos": "Toutes mes photos",
    "My amateur videos": "Mes vidéos amateurs",
    "Upload a video": "Publier une vidéo",
    "All my amateur videos": "Toutes mes vidéos",
    "Any content not in accordance with CGU will be blocked by administrators by disabling your account (photos of children, email address, website address, ....).": "Tout contenu non conforme aux CGU sera bloqué par l'administrateur et entraînera la suppression de votre compte (photo d'enfant, adresse email, adresse de site, ....).",
    "My posts on The Wall": "Mes posts sur Le Mur",
    "New post": "Ajouter un post",
    "All my posts on The Wall": "Tous mes posts sur le mur",
    "All my virtual gifts": "Tous mes cadeaux virtuels",
    "My wishlist on": "Ma liste d'envies sur",
    "Add to wishlist": "Ajouter une envie",
    "Change avatar": "Changer d’avatar",
    "Select photo": "Sélectionner une photo",
    "Preview:": "Aperçu :",
    "Set as avatar": "Choisir comme avatar",
    "Current email address:": "Adresse email actuelle",
    "New email address:": "Nouvelle adresse email",
    "New email address again:": "Confirmer la nouvelle adresse email",
    "Change nickname": "Changer de pseudo",

    "Drag your file here...": "Glisser votre fichier ici...",
    "Or add from...": "ou ajouter le à partir de...",

    // member profile - photos
    "Ask administator to blur faces on the photo": "Demander à Bob de masquer le visage sur cette photo.",
    "The uploaded image size should be at least 1024x768.": "La taille de la photo doit être de 1024x768 pixels au minimum.",
    "Public photos are visible to everyone (%1 photos maximum).": "Les photos publiques sont visibles par tous (%1 photos au maximum).",
    "XXL photos could be opened only by XXL members.": "Les photos XXL ne peuvent être ouvertes que par les membres XXL.",
    "For you, certified Bobeuse and Bobeur, simply attach a photo to your profile that shows you're a fan or an authentic fan Bob TV. This photo must show the name or logo of our favorite site. So you can enter \"Bob TV\" on a sheet of paper, on your skin or put computer screen in front of you... Be imaginative ;-)": "La photo certifiée doit faire apparaître le nom ou le logo de BobTV. Vous pouvez inscrire \"Bob TV\" sur une feuille de papier, sur votre peau ou poser devant l'écran de votre ordinateur, soyez imaginatif ;-)",
    "Upload": "Télécharger",
    "Edit a photo": "Modifier une photo",
    "Status:": "Statut :",
    "Public photos": "Photos publiques",
    "XXL photos": "Photos XXL",
    "Public photo": "Photo publique",
    "XXL photo": "Photo XXL",
    "Certified photos": "Photos certifiées",
    "Certified photo": "Photo certifiée",
    "Description:": "Description :",
    "%1 of %2": "%1 de %2",

    // member profile - amateur films
    "Publish a video": "Publier une vidéo",
    "Uploading...": "Téléchargement en cours...",
    "Edit video": "Modifier le vidéo",
    "Delete": "Supprimer",
    "Title of a video:": "Titre de la vidéo :",
    "I confirm that I am owner of this submitted file. I confirm that models on this material are over 18 years old.": "Je certifie être propriétaire de ce fichier et que les personnes exposées sont majeures et consentantes.",
    "I authorize the publication of this file on bobtv.fr": "J'autorise la publication de ce fichier sur le site bobtv.fr",
    "Video must have following formats: .mpeg, .wmv, .mov or .avi and do no exceed more than 300 Mb in size.": "La vidéo doit être au format .mpeg .wmv .mov ou .avi et ne pas dépasser 300 Mo.",
    "Do not submit compressed files: .zip, .rar, etc. and low-resolution videos": "N'envoyez pas de fichier compressé (.zip, .rar, ...) et seule une vidéo de bonne qualité sera publiée sur le site.",
    "You need confirm that you are owner and the models on your materials are adult.": "Veuillez certifier que vous êtes le propriétaire de ce fichier et que le modèle est majeur.",
    "Please confirm that you authorize publication of these files on bobtv.fr": "Veuillez confirmer que vous autorisez la publication de ce fichier sur bobtv.fr.",
    "Confirm your contribution": "Confirmez votre contribution",
    "Sort by:": "Trier par :",
    "Films found:": "Vidéos trouvées :",
    "date": "date",
    "popularity": "popularité",

    // member profile - wall
    "Send to the Wall": "Poster sur le Mur",
    "Title of your post:": "Titre de votre post :",
    "I confirm that I am owner of these submitted files. I confirm that models on these materials are over 18 years old.": "Je certifie être propriétaire de ce fichier et que les personnes exposées sont majeures et consentantes.",
    "Use this form to post your photo or video on the Wall of BobTV.": "Utilisez ce formulaire pour poster votre photo ou vidéo sur le Mur de BobTV.",
    "Your post will appear immediately above the chat rooms and on The Wall. Please note that your video will be available in 5 to 10 minutes after submit because it takes some time to prepare it.": "Comptez 5 minutes de délai pour une vidéo en raison du temps de formatage.",
    "Do you really want to delete your material \"<strong class='nickname'>%1</strong>\"?": "Voulez-vous vraiment supprimer votre contribution \"<strong class='nickname'>%1</strong>\"?",

    // member profile - virtual gifts
    "You have <strong>%1</strong> gift points": "Vous avez <strong>%1</strong> points-cadeaux.",
    "Virtual gifts have a value defined by the number of points.": "Les cadeaux virtuels ont une valeur définie en nombre de points.",
    "Every received gift credits your virtual account with the number of gift points that reflect the value of the gift.": "Chaque cadeau virtuel reçu crédite votre compte du nombre de points-cadeaux qui correspondent à la valeur du cadeau.",
    "Virtual gifts are permanently displayed on your profile.": "Les cadeaux virtuels sont affichés définitivement sur votre profil.",
    "Gift points accumulated on your account are valid for 60 days and allow you to participate in the ranking of BobTV favorites.": "Les points-cadeaux cumulés sur votre compte sont valables 60 jours et vous permettent de participer au classement des profils favoris de BobTV.",
    "...and if you have over 500 gift points you receive a golden star": "...et au-dessus de 500 points-cadeaux vous serez gratifié d'une étoile or",
    "You can hide your virtual gifts, they will not be displayed on your profile and corresponding gift points will no longer be counted.": "Vous pouvez cacher vos cadeaux virtuels, ils ne seront plus affichés sur votre profil et les points-cadeaux correspondants ne seront plus comptabilisés.",
    "to give to": "pour offrir à",

    "Give this virtual gift": "Offrir ce cadeau virtuel",

    'From:': 'De :',
    'To:': 'À :',
    'Attachment:': 'Photo jointe :',
    'Choose file': 'Choisir un fichier',
    'Expose you nick to:': 'Affichez votre pseudo à :',
    'Private message (optional):': 'Message privé (optionnel) :',

    "By giving this virtual gift, your virtual wallet will be debited with the number of tokens corresponding to the value of the gift.": "En offrant ce cadeau virtuel, votre porte-monnaie virtuel sera débité du nombre de jetons correspondant à la valeur du cadeau.",
    "You can attach a message and/or a photo to this virtual gift. This message and this picture will remain confidential, only the recipient can see them.": "Vous pouvez joindre un message et/ou une photo à ce cadeau virtuel. Ce message et cette photo resteront confidentiels, seul le destinataire en aura connaissance.",
    "Your virtual gift (without your message and your photo) will be displayed on the profile page of the recipient.": "Votre cadeau virtuel (sans votre message et votre photo) sera affiché sur la page profil du destinataire.",
    "You can choose between 3 options:": "Vous pouvez choisir entre 3 options:",
    "- Show your nickname to: All": "- Affichez votre pseudo à : Tous",
    "Your nickname will be visible to all users on the profile page of the recipient.": "Votre pseudo sera visible par tous les utilisateurs sur la page profil du destinataire.",
    "- Show your nickname to: Recipient only": "- Affichez votre pseudo à : Seulement au destinataire",
    "Your nickname will be visible only to the recipient.": "Votre pseudo sera visible uniquement par le destinataire.",
    "- Show your nickname to: Nobody": "- Affichez votre pseudo à : Personne",
    "Your nickname will not be visible neither to the recipient nor to other users.": "Votre pseudo ne sera pas visible par le destinataire, ni par les autres utilisateurs.",
    "Your virtual gift will be anonymous.": "Votre cadeau virtuel sera anonyme.",

    "%1 Points": "%1 Points",
    "View message": "Lire le message",

    "Show the gift": "Voir le cadeau virtuel",
    "Show attached photo": "Voir le photo jointe",

    // Messages
    'Conversation': 'Conversation',
    'No messages': 'Pas de message',
    'New message': 'Nouveau message',
    'Mark as read': 'Marquer comme lu',
    'Move to inbox': 'Déplacer vers la boîte de réception',
    'Delete permanently': 'Supprimer définitivement',
    'Apply': 'Appliquer',
    'Trash': 'Corbeille',
    'Enter your message': 'Entrez votre message',
    'Selected': 'Sélectionné',
    'Revoke permission': 'Révoquer le MP',
    'Delete history': 'Effacer le MP',
    'My Requests': 'Mes Demandes',
    'Archive': 'Archives',

    // wallet
    'Pending gifts': 'Cadeaux en attente',
    'History': 'Historique',
    'Replenish': 'Créditer',
    'Back': 'Retour',
    '%1 tokens': '%1 jetons',
    '%1 token': '%1 jeton',

    'Your virtual wallet contains tokens.': 'Votre porte-monnaie virtuel contient des jetons.',
    'You can purchase these tokens by crediting your virtual wallet by a secure online payment.': 'Vous pouvez acheter ces jetons en créditant votre porte monnaie virtuel par un paiement en ligne sécurisé.',
    'The validity duration of the tokens is unlimited. You can use them in two ways:': 'La durée de validité des jetons est illimitée. Vous pouvez les utiliser de deux façons :',
    '- to give virtual gifts to the users of your choice. Then they will get popularity stars (blue, red or gold).' : '- pour acheter et offrir des cadeaux virtuels aux utilisateurs de votre choix. Ils obtiendront alors des étoiles de popularité (bleue, rouge ou or).',
    '- to offer tokens directly to the users of your choice. They will be able to shop at the %2 by paying them with their accumulated tokens and you will get a medal of generosity (blue, red or gold).': '- pour les offrir directement aux utilisateurs de votre choix. Ils pourront faire des achats sur la boutique %1 en les payant avec leurs jetons cumulés et vous obtiendrez alors une cocarde de générosité (bleue, rouge ou or).',

    '%1 tokens in your virtual wallet': '%1 jetons dans votre porte monnaies virtuel',

    'Give a virtual gift to %1': 'Offrir un cadeau virtuel à %1',
    'Back to profile of %1': 'Retour au profil de %1',

    '%1 gift points': '%1 points-cadeaux',
    'Token from ': 'Jeton de ',
    'Token for ': 'Jeton pour ',
    'Tokens from ': 'Jetons de ',
    'Tokens for ': 'Jetons pour ',

    // wallet charge
    'token': 'jeton',
    'tokens': 'jetons',
    'Confirm': 'Confirmer',
    'Return to Bobstore': 'Retourner sur Bobstore',
    'Order not found': 'Commande non trouvée',
    'Order has already been paid': 'La commande est déjà payée',
    'Insufficient funds': 'Crédit insuffisant',
    'Order not paid': 'Votre paiement a échoué, veuillez recommencer',
    'You are going to spend %1 for <a href="https://bobstore.fr">Bobstore.fr</a> order %2.': 'Vous allez dépenser %1 sur <a href="https://bobstore.fr">Bobstore.fr</a> pour payer la commande #%2.',
    'You have %1 available at your wallet.': 'Vous avez %1 disponibles dans votre porte monnaie virtuel.',
    // wishlist
    "The gifts will be delivered to %1 by Bob in 3 days max!": "Les cadeaux offerts à %1 lui seront livrés par Bob en 3 jours maxi!",

    // guestbook
    "My guestbook": "Mon livre d'or",
    "Disable my guestbook": "Désactiver mon livre d'or",
    "All of my guestbook": "Tous mes messages",
    "Guestbook": "Livre d'or",
    "Do you really want to delete this message?": "Voulez-vous vraiment supprimer ce message?",

    // member profile - following
    'Location': 'Localisation',
    'Search by name': 'Recherche par pseudo',
    'My followers': 'Mes abonnés',
    'Members I follow': 'Mes abonnements',
    'Followers': 'Abonnés',
    'Please wait...': "S\'il vous plaît, attendez ...",

    // member profile - blackList
    'Black list': 'Black liste',
    'List of blocked users': 'Liste des utilisateurs bloqués',
    'Blocking duration': 'Durée du blocage',
    'Describe your reason': 'Raison du blocage',
    'Enter nick of the user': "Pseudo de l'utilisateur",
    'Adding date': "Date d'ajout",
    'Reason': 'Raison',
    'Expiration date': 'Fin du blocage',
    'unblock': 'supprimer',
    'hours': 'heures',
    'User': 'Utilisateur',
    'Never': 'Jamais',
    'Add': 'Ajouter',
    'If you add a nick to your black list, that user will no longer send you any message on site.': 'Si vous bloquez un utilisateur, Il ne pourra plus vous lire, regarder votre vidéo sur les salles BobTV I, BobTV II et My BobTV et vous envoyer de message sur le site.',
    'If you are My BobTV room creator, that user will not be able to stay in your room.': 'Si vous ouvrez une salle My BobTV, il ne pourra pas se connecter sur votre salle.',
    'The number of permanently blocked users is limited to 20 users.': 'Le nombre des blocages définitifs est limité à 20 utilisateurs.',
    'Do not block without reason!': 'Ne bloquez pas sans raison!',

    // profile
    "Follow": "Suivre",
    "Unfollow": "Ne plus suivre",
    "Give": "Offrir",
    "views": "vues",
    "followers": "abonnés",

    "Denounce": "Dénoncer",
    "You can denounce this profile to Bob if you think its content is punishable by law and regulations.": "Vous pouvez dénoncer ce profil à Bob si vous jugez que son contenu est réprimé par la Loi et les réglements.",
    "Denounce %1": "Dénoncer %1",
    "Do you really want to denounce this user to the site's administrator?": "Voulez vous vraiment dénoncer cet utilisateur à l'administrateur du site?",
    "Reason:": "Raison :",

    "Your information is taken into account and will be reviewed promptly by an administrator.": "Votre dénonciation est prise en compte et sera examinée rapidement par un administrateur.",
    "You already denounced this profile.": "Vous avez déjà dénoncé ce profil.",

    "Block": "Bloquer",
    "Block %1": "Bloquer %1",
    "For how long?": "Durée du blocage :",
    "For 24 hours": "Pour 24 heures",
    "Permanent": "Permanent",
    "Unblock": "Débloquer",
    "Unblock %1": "Débloquer %1",
    "Why would you add to your black list %1?": "Pour quelle raison voulez-vous bloquer %1?",
    "Do you want to unblock %1?": "Voulez-vous débloquer %1?",
    "If you block a user he will not be able to read your messages, watch your video and send you messages.": "Si vous bloquez un utilisateur il ne peut plus vous lire, regarder votre vidéo et vous envoyer de messages.",
    "Do not block without a reason!": "Ne bloquez pas sans raison!",

    "Become XXL member": "Devenez membre XXL",
    "You need to become XXL to use this feature.": "Vous devez être membre XXL pour utiliser cette fonction.",

    "Sorry, you're blocked by %1.": "Désolé, vous êtes bloqué par %1.",

    "Album": "Album photos",
    "See all photos": "Voir toutes les photos",
    "See all amateur videos": "Voir toutes les vidéos",
    "Posts on the Wall": "Posts sur le Mur",
    "To be published": "Être publié",
    "Untitled": "Sans titre",
    "See all posts on the Wall": "Voir tous les posts",
    "Virtual gifts": "Cadeaux virtuels reçus",
    "given by": "offert par",
    "See all virtual gifts": "Voir tous les cadeaux virtuels",
    "Give a virtual gift": "Offrir un cadeau virtuel",
    "Wishlist on": "Liste d'envies sur",
    "Wishes on": "Les envies sur",
    "Guest book": "Livre d'or",
    "Add a comment": "Ajouter un commentaire",
    "See all guestbook": "Lire tous les commentaires",
    "Return the favor": "Retourner la faveur",
    "Send a message": "Envoyer un message",
    "Hide": "Cacher",

    "I am online at": "Je suis connecté sur la salle",
    "Last online at %1": "Dernière connexion le %1",
    "Back to profile": "Retour au profil",

    "Add message to guestbook of %1": "Ajoutez un commentaire au livre d'or de %1",

    "Certified Bobeur": "Bobeur certifié",
    "Certified Bobeuse": "Bobeuse certifiée",

    // registration
    "Nick:": "Pseudo :",
    "Email:": "Email :",
    "Password:": "Mot de passe :",
    "Please make sure your passwords match": "Please make sure your passwords match",
    "Confirm password:": "Confirmez le mot de passe :",
    "Confirm email address:": "Confirmez l'adresse email :",
    "Alternative email:": "Deuxième email :",
    "You can start using BobTV" : "Vous pouvez commencer à utiliser BobTV.",

    "After submitting this form you will receive an email which lets you to activate your free account. Be sure to specify a valid address to receive this email.": "Après avoir validé ce formulaire, vous allez recevoir un émail qui vous permettra d'activer votre compte gratuit. Prenez soin d'indiquer une adresse valide afin de recevoir ce message.",
    "Some free email such as Hotmail may consider the activation mail as spam. It is recommended to specify a second email address on a different domain. The activation message will be sent to both addresses.": "Certaines messageries gratuites telles que Hotmail risquent de considérer le mail d'activation comme un Spam. Il est souhaitable d'indiquer une deuxième adresse émail sur une messagerie différente. Le message d'activation vous sera envoyé aux deux adresses.",

    "years": "ans",

    "Congratulations!": "Félicitation!",
    "Activation": "Activation",
    "Please enter the activation code we sent to your email <span class=\"underline\">%1</span> or clicking the activation link from email message.":
        "Entrez le code d'activation envoyé à votre adresse <span class=\"underline\">%1</span> ou cliquez sur le lien d'activation contenu dans cet émail.",

    "If you do not receive this email immediately, check your \"spam\" folder and mark this as \"non-spam\".":
        "Si vous ne recevez pas cet émail immédiatement, vérifiez votre dossier \"spam\" et marquez ce message comme \"non-spam\".",

    "If you can not find this email, activate your account par SMS or %1 so that I manually activate your account.":
        "Si vous ne retrouvez pas cet émail, activez votre compte par SMS ou %1 afin que j'active manuellement votre compte",
    "contact me": "contactez-moi",
    "I'm already registered": "Je suis déjà inscrit",
    "Confirm your registration": "Confirmer votre enregistrement",
    "Your account registration is confirmed.": "Votre enregistrement est confirmé.",
    "Account activation": "Activation de compte",
    "Please confirm you are not a robot": "Veuillez confirmer que vous n'êtes pas un robot",

    "Message with the password reset instructions has been sent to your email.": "Un email vient de vous être envoyé. Il contient les instructions pour renouveler votre mot de passe.",
    "New password": "Nouveau mot de passe",
    "Confirm new password": "Confirmez le nouveau mot de passe",
    "Your profile data have been saved.": "Vos données de profil ont été sauvées.",
    "Password recover": "Recevez votre mot de passe",

    "A confirmation link has been sent to %1. Please check your mailbox and follow the link to verify your new email address.": "Un lien de confirmation est envoyé à %1. Veuillez consulter votre boîte de réception et suivre ce lien pour vérifier votre nouvelle adresse émail.",

    // amateur films
    "Amateur videos of bobbesies and bobbers": "Les vidéos amateurs des bobeuses et bobeurs",
    'Show all tags': 'Montrer tous les mots clés',
    'Selected tag:': 'Mot-clé sélectionné :',
    "Publish your video": "Publiez votre vidéo amateur",
    "You should be an XXL member to watch entire videos.": "Vous devez être membre XXL pour visionner les vidéos.",
    "Become an XXL member": "Devenir membre XXL",

    // wall
    "Post a photo or a video to the Wall here or from your profile page.": "Postez une photo ou une vidéo sur le Mur de BobTV à partir de cette page ou depuis votre profil.",
    "Your post will be shown immediately on this page and at BobTV chatrooms.": "Votre post sera affiché immédiatement sur Le Mur et sur les salles BobTV.",

    // wardrobe
    'Bobstore wardrobe': 'Le dressing de Bobstore',
    'Add wardrobe post': 'Ajouter au dressing',
    'Add your photo': 'Ajouter votre photo',
    'A gift from': 'Article présenté par',
    'Select Bobstore product': "Sélectionner l'article Bobstore",
    "Use this form to post your photo or video to the Bobstore wardrobe.": "Utilisez ce formulaire pour poster votre photo ou vidéo dans le dressing de Bobstore.",
    "You can't contribute to the wardrobe because you don't have any product from bobstore": "Vous ne pouvez pas contribuer au dressing car vous n'avez pas acheté ou reçu un article de Bobstore.",

    // wishlists
    "Wishlists of members": "Les listes d'envies des membres",
    "Check wishlists and give real gifts to BobTV members.<br/>The real gifts are for sale on %1 the online shop of Bob. Gifts you offer are shipped via Colissimo in 24 hours.<br/>Only Bob can see the delivery address of members that created a wishlist on Bobstore.<br/>To please a BobTV member offering him a gift, just add an article (or more) from the wishlist to your basket and confirm your purchase.<br/>Do not hesitate, give a gift by clicking on the link \"Give as a gift\".<br/>Bob will do the rest and your gift will be delivered as soon as possible.": "Consultez les listes d'envies et offrez des cadeaux réels aux membres de BobTV.<br/>Les cadeaux réels sont en vente sur %1 la boutique en ligne de Bob.<br/>Les cadeaux que vous offrez sont expédiés en Colissimo dans le 24 heures.<br/>Seul Bob a connaissance de l'adresse de livraison des membres ayant créé une liste d'envies sur Bobstore.<br/>Pour faire plaisir à un(e) membre de BobTV en lui offrant un cadeau, il suffit d'ajouter un article (ou plus) de sa liste d'envies dans votre panier et de valider votre achat.<br/>N'hésitez pas, offrez un cadeau en cliquant sur les liens \"Offrez moi ce cadeau réel\".<br/>Bob s'occupe du reste et votre cadeau sera livré dans les plus brefs délais.",
    "Check wishlists and give real gifts to BobTV members.<br/>The real gifts are for sale on %1 the online shop of Bob. Gifts you offer are shipped via Colissimo in 24 hours...": "Consultez les listes d'envies et offrez des cadeaux réels aux membres de BobTV.<br/>Les cadeaux réels sont en vente sur %1 la boutique en ligne de Bob.<br/>Les cadeaux que vous offrez sont expédiés en Colissimo dans le 24 heures....",
    "Give as a gift": "Offrez moi ce cadeau réel",
    "View full wishlist": "Voir toutes les envies",
    "Sorry, there is no wishlists found.": "Désolé, il n'y a pas de liste d'envies trouvée.",
    "View all wishlists": "Voir toutes les listes d'envies",

    // contact
    "If your message is related to a technical problem, please visit %1. This page has answers for all frequently asked questions.": "Si votre message concerne un problème technique, je vous invite à consulter la %1. Vous trouverez sur cette page toutes les réponses aux questions les plus fréquentes.",
    "Help page": "page AIDE",
    "Message:": "Message :",
    "Free": "Gratuit",
    "XXL": "XXL",
    "Your message has been sent successfully. It will be processed within 24 hours.": "Votre message a été envoyé avec succès. Il sera traite en moins de 24 heures.",
    "Return": "Retour",

    // 404
    "Oops!": "Oups!",
    "The page you're looking for could not be found.": "La page que vous cherchez est inaccessible.",
    "Back to previous page": "Retour à la page précédente",
    'Legal notice': 'Mentions légales'
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/messages.js